
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, Icon, Menu} from "antd";
import BaseComponent from "../../../../../../base/BaseComponent";

export default class Media extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            source: '媒体不限',
            optionNameList:[]
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getMediaList()
    }

    render() {
        // let optionNameList = ["途径不限", "资源库上传", "投稿", "媒体稿件", "约稿", "采访", "线索", "选题", "新闻申请", "通知公告", "其他"];
        let {optionNameList} = this.state;
        let menu = (
            <Menu style={{marginTop:'7px'}} onClick={({item, key,}) => {
                this.selectMenu(key)
            }}>
                {
                    optionNameList && optionNameList.length && optionNameList.map(optionName =>
                        <Menu.Item style={{background: this.state.source === optionName.id ? "#e6f7ff" : ""}} value={optionName.key} key={optionName.key}>{optionName.key}</Menu.Item>
                    )
                }
            </Menu>
        );
        return (
            <Dropdown overlay={menu} trigger={["click"]} style={{display: 'none'}}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}
                >
                    {this.state.source}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }

    selectMenu(array) {
        let {optionNameList}=this.state;
        console.log(array,'array')
        this.state.source = array;
        this.setState({});
        let data = optionNameList&&optionNameList.length&&optionNameList.filter(item=>item.key === array)
          data = data[0].value? data[0].value:'';

        if (typeof this.props.onClickCall == "function") {
            this.props.onClickCall([{type:'type', data}])
        }
    };

    getMediaList =()=>{
        this.request({
            url: '/search-server/search/getListFromConfig?optionsNames=storyMediaType',
            method: "get",
            contentType: 'json',
            callBack: (res) => {
                let optionNameList = [];
                if(res && res.storyMediaType){
                    optionNameList = res.storyMediaType;
                }
                this.setState({optionNameList})
            }
        })
    }
}